import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { FEATURE_FLAG_ME } from '../apis';

// 目前登入帳號的 feature flag 對照表：{ [flagKey]: boolean }。
// 由 malasun GET /api/v1/feature-flag/me 提供（只回自己的 flag）。
export type FeatureFlags = Record<string, boolean>;

// 已知的 flag key（跟後端 featureFlag.constants 對齊）。
// 已全面開放並拆除 gate 的 flag 不在此列（2026-09 拆：downstream-edit、
// mobile-full-edit、comment-reply-duplicate、einvoice-download）。
export const FEATURE_FLAG_KEYS = {
  // IG flow 編輯器「追蹤檢查」節點（request to follow）。已全開但 flag 保留：
  // 追蹤解鎖模板迴圈事故（2026-08-29）止血拍板前，「全部關閉」是現成緊急開關
  IG_FOLLOW_CHECK: 'ig-follow-check',
} as const;

async function getFeatureFlags(): Promise<FeatureFlags> {
  return axios
    .get(FEATURE_FLAG_ME)
    .then((res) => (res?.data?.data?.flags as FeatureFlags) ?? {})
    // 端點還沒部署 / 未登入 / 任何錯誤 → 視為「全部關閉」（安全預設，不影響其他使用者）
    .catch(() => ({} as FeatureFlags));
}

export function useGetFeatureFlags() {
  return useQuery<FeatureFlags>({
    queryKey: ['get-feature-flags'],
    queryFn: getFeatureFlags,
    // flag 不常變，減少請求；切帳號時 react-query 換 key/重登入會重取
    staleTime: 5 * 60 * 1000,
  });
}

export default useGetFeatureFlags;
